




import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { StandardOption } from "../../system/selectors/mixins";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";

@Component({
  components: {
    selector: OptionDropDownSelector,
  }
})
export default class DocumentDurationKindDropDownSelector extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      options: [
        new StandardOption<boolean>("文書日付", true),
        new StandardOption<boolean>("更新日", false),
      ],
    };
  }
  options: StandardOption<boolean>[];
}
